import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
}

window.PraxenHtmx = function() {
    let endPoint = document.querySelector('[paws-component="noss-praxen"]').dataset.endpoint;
    let innerContent = document.querySelector('[paws-component="noss-praxen"] .innercontent');
    let searchFor = document.querySelectorAll('[paws-component="noss-praxen"] .fld-searchfor');
    let subFilter = document.querySelector('[paws-component="noss-praxen"] .fld-subfilter');
    let subFilter2 = document.querySelector('[paws-component="noss-praxen"] .fld-subfilter2');

    if (innerContent && endPoint) {
        let searchForValue = '';
        for (let i = 0; i < searchFor.length; i++) {
            if (searchFor[i].checked) {
                searchForValue = searchFor[i].value;
            }
        }

        let subFilterValue = '';
        if (subFilter && subFilter.value) {
            subFilterValue = subFilter.value;
        }
        else {
            if (subFilter2 && subFilter2.value) {
                subFilterValue = subFilter2.value;
            }
        }

        fetch(endPoint, {
            method: 'POST',
            body: JSON.stringify({
                searchfor: searchForValue,
                subfilter: subFilterValue,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8'
            }
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                innerContent.innerHTML = html;

                if (window.lazyLoadInstance) {
                    window.lazyLoadInstance.update();
                }
            });
    }
}